// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ve1r","left":"styles_left__3RHCm","desktopActions":"styles_desktopActions__ABJVV","title":"styles_title__2xcF5"};